/**
 * Mock-quiz intro screen.
 */
import React from "react";
import { useTranslation } from 'react-i18next';

import { VButton } from "form";

/**
 * Explains the quiz and starts the attempt.
 *
 * @param {{ onContinue?: Function }} props
 */
const QuizFirst = (props) => {

  const { totalCount, cutoff, onContinueClick } = props;

  const { t } = useTranslation('common');

  return <>
    <div className="w-full">
      <div className="fsp-20 mt-3">{totalCount}&nbsp;{t('questions')}</div>
      <div className="flex items-center flex-col shadow mt-5 p-4">
        <img className="size-70" src="https://files.plateformedoctonet.com/app-eduforma/Challenge.png" alt="" />
        <p className="font-bold fsp-18 text-muted">
          {t("It's time to test your new knowledge!")}
        </p>
        <p className="text-base">
          {t('To validate this quiz you need')}&nbsp;
          {Math.round(cutoff * 100)}%&nbsp;
          {t('correct answers')}&nbsp;
          ({Math.ceil(cutoff * totalCount)}&nbsp;
          {t('correct answers out of')}&nbsp;
          {totalCount})</p>
        <VButton onClick={onContinueClick} variant="contained">
          {t('Start the quiz')}
        </VButton>
      </div>
      <ul className="mt-4">
        <li>{t("You can start over as many times as you want. We promise, we'll only keep the best score.")}</li>
        <li>{t("Once this quiz is validated, the corresponding badge will be added to your collection, which will allow you to move forward for the final evaluation.")}</li>
      </ul>
    </div>
  </>
}

export default QuizFirst;